import { Menu } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import styled, { css, createGlobalStyle } from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

interface CategoryItemProps {
  active?: boolean;
}

interface CategoryMenuItemProps {
  active: number;
}

export const FilterContainer = styled.div<{ hasControls?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.hasControls ? 'space-between' : 'center'};
  background-color: #ff9500;
  border-top: 1px solid #d9d9d9;
  padding: 8px 16px;
  min-height: 64px;
  width: 100%;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FilterIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  color: #000;
  background-color: #fff;

  &:hover {
    background-color: #f5f5f5;
    color: #000;
  }

  .anticon {
    font-size: 18px;
  }
`;

export const CenterSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  max-width: 100%;

  .ant-menu {
    background-color: transparent;
    justify-content: flex-start;
    border: none;
    width: 100%;
  }

  .ant-menu-title-content::after {
    content: none !important;
  }

  .ant-menu-title-content {
    color: #fff !important;

    :hover {
      color: #fff !important;
    }
    transition: none !important;
  }

  .ant-menu-title-content,
  .ant-menu-submenu-title {
    color: #fff !important;

    :hover {
      color: #fff !important;
    }
  }

  .ant-menu-item-selected:not(.active-filter) {
    color: #fff !important;
  }

  .ant-menu-horizontal > .ant-menu-item::after,
  .ant-menu-horizontal > .ant-menu-submenu::after {
    content: none !important;
  }

  .ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item-selected:not(.active-filter) {
    color: #fff !important;
  }

  .ant-menu-submenu-title {
    > span {
      color: #fff !important;
    }
  }

  .ant-menu-overflow-item-rest .ant-menu-submenu-title .anticon {
    color: #fff;
    transition: all 0.2s ease;
  }

  .ant-menu-overflow-item-rest:hover .ant-menu-submenu-title .anticon {
    color: #fff;
  }

  .ant-menu-overflow-item-rest.ant-menu-submenu-open
    .ant-menu-submenu-title
    .anticon {
    transform: rotate(180deg);
    color: #fff;
  }
`;

export const ResponsiveMenu = styled(Menu)`
  background-color: transparent !important;
  border: none !important;
  width: 100%;
  max-width: 100% !important;

  .ant-menu-submenu-popup {
    background-color: #ff9500 !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    border-radius: 6px !important;
  }

  .ant-menu-submenu-popup .ant-menu {
    background-color: #ff9500 !important;
    border: none !important;
    border-radius: 6px !important;
  }

  .ant-menu-submenu-popup .ant-menu-item {
    color: #fff !important;
    background-color: transparent !important;
    border: none !important;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
      color: #fff !important;
    }

    &.ant-menu-item-active {
      background-color: rgba(255, 255, 255, 0.1) !important;
      color: #fff !important;
    }

    &.ant-menu-item-selected {
      background-color: rgba(255, 255, 255, 0.2) !important;
      color: #fff !important;
      font-weight: bold;
    }

    .ant-menu-title-content {
      color: #fff !important;
    }

    .ant-badge {
      color: #fff !important;

      strong {
        color: #fff !important;
      }
    }
  }

  .ant-dropdown {
    .ant-dropdown-menu {
      background: #fff !important;
      border-radius: 8px !important;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
      border: 1px solid #e0e0e0 !important;
      padding: 8px 0 !important;
      min-width: 180px !important;
    }

    .ant-dropdown-menu-item {
      padding: 12px 16px !important;
      color: #000 !important;
      border-radius: 0 !important;
      margin: 0 !important;

      &:hover {
        background-color: #f5f5f5 !important;
      }

      &.ant-dropdown-menu-item-selected {
        background-color: #fff5e6 !important;
        color: #ff9500 !important;
      }
    }
  }
`;

export const CategoryMenuItem = styled(Menu.Item)<CategoryMenuItemProps>`
  cursor: pointer;
  color: #fff !important;

  .ant-badge {
    color: #fff !important;
    font-weight: 400;
  }

  :hover {
    color: #fff !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  ${(props) =>
    css`
      color: #fff !important;
      font-weight: ${props.active ? 'bold' : 'normal'};

      &.active-filter {
        color: #fff !important;
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: #fff;
        text-decoration-thickness: 2px;
        text-underline-offset: 18px;
      }

      &.ant-menu-item-selected:not(.active-filter) {
        color: #fff !important;
      }
    `}
`;

export const CategoryItem = styled.div<CategoryItemProps>`
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
  position: relative;
  display: none;

  ${(props) =>
    props.active
      ? css`
          color: #ffac47;
          background-color: rgba(255, 172, 71, 0.1);

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 80%;
            height: 2px;
            background-color: #ffac47;
          }
        `
      : css`
          color: rgba(0, 0, 0, 0.85);

          &:hover {
            color: #ffac47;
            background-color: rgba(255, 172, 71, 0.05);
          }
        `}
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TabletOnlyText = styled.span<{
  variant?: 'primary' | 'secondary';
}>`
  display: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${(props) => (props.variant === 'secondary' ? '#000' : '#fff')};

  @media (min-width: ${BREAKPOINTS.tablet}) {
    display: inline;
  }
`;

export const GridIcon = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  color: #000;
  background-color: #fff;

  &:hover {
    background-color: #f5f5f5;
    color: #000;
  }

  .anticon {
    font-size: 18px;
  }
`;

export const DropdownContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ViewModeMenuItem = styled(Menu.Item)<{ $isSelected?: boolean }>`
  color: #000 !important;

  &:hover {
    background-color: #f5f5f5 !important;
  }
`;

export const ViewModeItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ViewModeIcon = styled.span<{ $isSelected?: boolean }>`
  color: ${(props) => (props.$isSelected ? '#ff9500' : '#000')};
`;

export const ViewModeText = styled.span<{ $isSelected?: boolean }>`
  color: ${(props) => (props.$isSelected ? '#ff9500' : '#000')};
  font-weight: ${(props) => (props.$isSelected ? '700' : 'normal')};
`;

export const ViewModeCheck = styled(CheckOutlined)`
  color: #ff9500;
  margin-left: auto;
`;

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const GlobalMenuStyles = createGlobalStyle`
  .ant-menu-submenu-popup.ant-menu-light {
    background-color: #ff9500 !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    border-radius: 6px !important;

    .ant-menu-sub.ant-menu-vertical {
      background-color: #ff9500 !important;
      border: none !important;
      border-radius: 6px !important;
    }

    .ant-menu-item {
      color: #fff !important;
      background-color: transparent !important;
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
        color: #fff !important;
      }

      &.ant-menu-item-active {
        background-color: rgba(255, 255, 255, 0.1) !important;
        color: #fff !important;
      }

      .ant-menu-title-content {
        color: #fff !important;
      }

      .ant-badge {
        color: #fff !important;
        
        strong {
          color: #fff !important;
        }
      }
    }
  }

  .ant-dropdown {
    .ant-dropdown-menu {
      background: #fff !important;
      border-radius: 8px !important;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
      border: 1px solid #e0e0e0 !important;
      padding: 8px 0 !important;
      min-width: 180px !important;
    }

    .ant-dropdown-menu-item {
      padding: 12px 16px !important;
      color: #000 !important;
      border-radius: 0 !important;
      margin: 0 !important;
      
      &:hover {
        background-color: #f5f5f5 !important;
      }
      
      &.ant-dropdown-menu-item-selected {
        background-color: #fff5e6 !important;
        color: #ff9500 !important;
      }
    }
  }
`;
